import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=0d8fab6b&"
import script from "./manual.vue?vue&type=script&lang=js&"
export * from "./manual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\kaharmanny\\source\\repos\\rentmagic.frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8fab6b')) {
      api.createRecord('0d8fab6b', component.options)
    } else {
      api.reload('0d8fab6b', component.options)
    }
    module.hot.accept("./manual.vue?vue&type=template&id=0d8fab6b&", function () {
      api.rerender('0d8fab6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/interface/manual.vue"
export default component.exports